import { Component, OnInit } from '@angular/core';
import { setting } from '../../../../../setting';

@Component({
  selector: 'usb-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
export class NoteComponent implements OnInit {

  public getClientsSettingAppBooking: any;

  constructor() {
    this.getClientsSettingAppBooking =  JSON.parse((localStorage.getItem(setting.name)));
    console.log("llegando al capacitation/note component", this.getClientsSettingAppBooking);
   }

  ngOnInit() {
  }

}
